import React from 'react';
import { TreatmentAreasSection } from '../components/TreatmentAreasSection';
export function TreatmentAreasPage() {
  return <div className="pt-28" data-id="element-812">
      <TreatmentAreasSection data-id="element-813" />
    </div>;
}